import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import { TGender } from "../../../../../../../Types";
import OneOTwoMessageHistoryButton from "./OneOTwoMessageHistoryButton";
import OneOTwoMessageReactions from "./OneOTwoMessageReactions";

const OneOTwoMessageReactionBar = withLiteObserverAndTheme<{
  conversationID: string;
  messageId: number;
  hasReactionHistory: boolean;
  isKhattabaMessage: boolean;
  senderGender: TGender;
}>((props) => {

  const {
    conversationID,
    messageId,
    hasReactionHistory,
    isKhattabaMessage,
    senderGender,
    theme
  } = props;
  const { unitX, colors } = theme;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        paddingLeft: 12,
        paddingRight: 12,
        boxSizing: "border-box"
      }}
    >
      <div
        style={{
          width: 650 * unitX,
          height: 2,
          backgroundColor: colors.all.translucentWhite,
          marginTop: 6,
          marginBottom: 8
        }}
      />

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
          paddingBottom: 8
        }}
      >
        <OneOTwoMessageReactions
          conversationID={conversationID}
          messageId={messageId}
        />

        {hasReactionHistory ? (
          <OneOTwoMessageHistoryButton
            conversationID={conversationID}
            messageId={messageId}
            isKhattabaMessage={isKhattabaMessage}
            senderGender={senderGender}
          />
        ) : null}
      </div>
    </div>
  );
})

export default OneOTwoMessageReactionBar;